import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

interface ChatHeaderProps {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export function ChatHeader(props: ChatHeaderProps) {
  const { title, description, actions, children } = props;

  return (
    <Box className="sendbird-custom-chat-header">
      <Stack spacing={4}>
        <Stack spacing={1}>
          <Text variant="h6">{title}</Text>
          <Text variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {description}
          </Text>
        </Stack>
        {actions}
        {children}
      </Stack>
    </Box>
  );
}
